function initAllIngredientSections() {
  const wrappers = document.querySelectorAll('.piw-wrapper:not([data-initialized])');
  
  wrappers.forEach(wrapper => {
    wrapper.setAttribute('data-initialized', 'true');
    const sectionId = wrapper.id.replace('IngredientWidget-', '');
    
    // --- CAROUSEL LOGIC ---
    const track = wrapper.querySelector('.piw-carousel');
    const slides = wrapper.querySelectorAll('.piw-slide');
    const prevBtn = wrapper.querySelector('.piw-prev');
    const nextBtn = wrapper.querySelector('.piw-next');
    const pills = wrapper.querySelectorAll('.piw-pill');
    let currentIndex = 0;

    function updateActiveSlide(index) {
      index = parseInt(index);
      slides.forEach(s => s.classList.remove('is-active'));
      pills.forEach(p => p.classList.remove('is-active'));
      if(slides[index]) slides[index].classList.add('is-active');
      if(pills[index]) pills[index].classList.add('is-active');
      currentIndex = index;
    }

    function handleScroll() {
      if (!slides.length) return;
      const slideWidth = slides[0].offsetWidth;
      let newIndex = Math.round(track.scrollLeft / slideWidth);
      if (newIndex >= slides.length) newIndex = slides.length - 1;
      if (newIndex < 0) newIndex = 0;
      if (newIndex !== currentIndex) updateActiveSlide(newIndex);
    }

    let scrollTimeout;
    if(track) {
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(handleScroll, 50); 
      });
    }

    if(prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => {
        let targetIndex = currentIndex - 1;
        if (targetIndex < 0) targetIndex = slides.length - 1; 
        track.scrollTo({ left: slides[targetIndex].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', () => {
        let targetIndex = currentIndex + 1;
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (targetIndex >= slides.length || track.scrollLeft >= maxScroll - 10) targetIndex = 0; 
        track.scrollTo({ left: slides[targetIndex].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    }

    pills.forEach((pill) => {
      pill.addEventListener('click', (e) => {
        const index = e.target.getAttribute('data-index');
        track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });

    function toggleArrows() {
      if(!track) return;
      if(track.scrollWidth <= track.clientWidth) {
          if(prevBtn) prevBtn.style.display = 'none';
          if(nextBtn) nextBtn.style.display = 'none';
      } else {
          if(prevBtn) prevBtn.style.display = 'flex';
          if(nextBtn) nextBtn.style.display = 'flex';
      }
    }
    window.addEventListener('resize', toggleArrows);
    setTimeout(toggleArrows, 100); 
    updateActiveSlide(0);

    // --- DRAWER LOGIC ---
    const triggers = wrapper.querySelectorAll('[data-drawer-trigger]');
    const newOverlay = document.getElementById(`piw-overlay-${sectionId}`);
    const body = document.body;

    // Move overlay to body safely
    if (newOverlay && newOverlay.parentNode !== body) {
      newOverlay.setAttribute('data-section-id', sectionId);
      body.appendChild(newOverlay);
    }

    function openDrawer(index) {
      let drawer = document.getElementById(`piw-drawer-${sectionId}-${index}`);
      
      // --- NEW TEMPLATE CLONE LOGIC ---
      if (!drawer) {
        const template = document.getElementById(`template-drawer-${sectionId}-${index}`);
        if (template) {
          body.appendChild(template.content.cloneNode(true));
          drawer = document.getElementById(`piw-drawer-${sectionId}-${index}`);
        }
      }

      if(drawer) {
        drawer.classList.add('is-open');
        if(newOverlay) newOverlay.classList.add('is-active');
        body.style.overflow = 'hidden'; 
        
        // --- AJAX LAZY LOAD LOGIC ---
        const productContainer = drawer.querySelector('.piw-drawer-slider');
        
        if (productContainer && productContainer.dataset.loaded === 'false') {
          const query = productContainer.dataset.searchQuery;
          
          if (query) {
            fetch(`${window.Shopify.routes?.root || '/'}search?type=product&q=${encodeURIComponent(query)}&section_id=ajax-product-cards`)
              .then(response => response.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const listItems = doc.querySelectorAll('li');
                
                productContainer.innerHTML = ''; 
                
                if (listItems.length > 0) {
                  listItems.forEach(li => productContainer.appendChild(li));
                } else {
                  productContainer.innerHTML = '<p style="padding-left: 20px; opacity: 0.6;">Products currently unavailable.</p>';
                }
                
                productContainer.dataset.loaded = 'true';
              })
              .catch(err => {
                console.error('Failed to load products', err);
                productContainer.innerHTML = '<p>Failed to load products.</p>';
              });
          }
        }
      }
    }

    triggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (window.getSelection().toString().length > 0) return; 
        openDrawer(btn.getAttribute('data-drawer-trigger'));
      });
    });
  });

  // --- GLOBAL CLOSE LOGIC ---
  if (!window.ingredientGlobalCloseAttached) {
    document.body.addEventListener('click', (e) => {
      const isCloseBtn = e.target.closest('.piw-drawer-close');
      const isOverlay = e.target.classList.contains('piw-drawer-overlay');

      if (isCloseBtn || isOverlay) {
        document.querySelectorAll('.piw-drawer.is-open').forEach(d => d.classList.remove('is-open'));
        document.querySelectorAll('.piw-drawer-overlay.is-active').forEach(o => o.classList.remove('is-active'));
        document.body.style.overflow = '';
      }
    });
    window.ingredientGlobalCloseAttached = true;
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initAllIngredientSections);

// Re-initialize if the section is added/edited in the Shopify Theme Editor
document.addEventListener('shopify:section:load', (event) => {
  setTimeout(initAllIngredientSections, 50);
});